export const MSG_TYPES = {
  USER_NAME: "USER_NAME",
  SETTINGS: "SETTINGS",
  MOVE: "MOVE",
  CHESS_CLIENT: "CHESS_CLIENT",
  GAME_STATUS: "GAME_STATUS",
};

export const SIGNAL_TYPES = {
  START_GAME: "START_GAME",
  OFFER_REMATCH: "OFFER_REMATCH",
  REMATCH_OFFER_ACCEPTED: "REMATCH_OFFER_ACCEPTED",
  REMATCH_OFFER_DECLINED: "REMATCH_OFFER_DECLINED",
  OFFER_DRAW: "OFFER_DRAW",
  DRAW_OFFER_ACCEPTED: "DRAW_OFFER_ACCEPTED",
  DRAW_OFFER_DECLINED: "DRAW_OFFER_DECLINED",
  REQUEST_TAKEBACK: "REQUEST_TAKEBACK",
  TAKEBACK_REQUEST_ACCEPTED: "TAKEBACK_REQUEST_ACCEPTED",
  TAKEBACK_REQUEST_DECLINED: "TAKEBACK_REQUEST_DECLINED",
  RESIGN: "RESIGN",
  ILLEGAL_MOVE_LOST: "ILLEGAL_MOVE_LOST",
};